import { sql, eq, desc } from "drizzle-orm";
import { integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import { getDb } from "../db";

export type SelectToken = typeof Token.$inferSelect;
export type InsertToken = typeof Token.$inferInsert;

export const Token = sqliteTable('Token', {
	address: text('tokenAddress').primaryKey(),
	symbol: text('symbol').notNull(),
	name: text('name'),
	description: text('description'),
	iconUrl: text('iconUrl'),
	infoUrl: text('infoUrl'),
	divisibility: integer('divisibility'),
	bidPrice: real('bidPrice'),
	askPrice: real('askPrice'),
	lastPrice: real('lastPrice'),
	tvlUSD: real('tvlUSD')
});

export function storeToken(token: InsertToken) {
	return getDb()
		.insert(Token)
		.values(token)
		.onConflictDoUpdate({
			target: Token.address, set: {
				symbol: token.symbol,
				name: token.name,
				description: token.description,
				iconUrl: token.iconUrl,
				infoUrl: token.infoUrl,
				divisibility: token.divisibility
		 } })
		.returning({ address: Token.address })
}

export function storeTokenPrice(tokenAddress: string, lastPrice: number | null, bidPrice: number, askPrice: number, tvlUSD: number) {
	return getDb()
		.update(Token)
  		.set({ lastPrice, askPrice, bidPrice, tvlUSD })
  		.where(eq(Token.address, tokenAddress));
}

export function storeTokenTVL(tokenAddress: string, tvlUSD: number) {
	return getDb()
		.update(Token)
		.set({ tvlUSD })
		.where(eq(Token.address, tokenAddress));
}

export async function getTokens() {
	return getDb()
		.select()
		.from(Token)
		.all();
}

export async function getTokensLimited(limit: number, offset: number) {
	return getDb()
		.select()
		.from(Token)
		.orderBy(desc(Token.tvlUSD))
		.limit(limit).offset(offset);
}

export async function getToken(address: string) {
	return getDb()
		.select()
		.from(Token)
		.where(eq(Token.address, address))
		.all();
}

export async function countTokens(): Promise<number> {
	const result = await getDb()
		.select({ count: sql<number> `count(*)` })
		.from(Token)
		.all();

	return result[0].count;
}
